export const stringToDate = (stringDate: string) =>
  new Date(stringDate.replace(/(\d{2})\-(\d{2})\-(\d{4})/, "$3-$2-$1"));

export const getDayDiff = (startDate: Date, endDate: Date): number => {
  const msInDay = 24 * 60 * 60 * 1000;
  return Math.round(Math.abs(Number(endDate) - Number(startDate)) / msInDay) + 1;
};
